<template>
	<div class="table">
		<div style="padding: 10px 0 0 10px; display: flex; gap: 10px;">
			<Commonbtn backgroundColor="#FFF" title="导出（横版）" fontSize="14px" @btnclick="Export"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出（列表）" fontSize="14px" @btnclick="ExportList"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
		</div>
		<div class="tables">
			<Commontable :loadingTable="false" :tableData="tableData" :headerData="headerData" :colnum="7" height="100%">
			</Commontable>
		</div>
		<div style="height: 10px;"></div>
		<div style="text-align: right;padding: 20px;">
			<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
				:pageNo="pageNo" :pageSize="pageSize" :total="total" type="all"></Pagination>
		</div>
	</div>
</template>

<script>
	import Commontable from '@/components/common-table.vue'
	import Pagination from '@/components/pagination.vue'
	import Commonbtn from '@/components/common-btn.vue'
	export default {
		components: {
			Commontable,
			Pagination,
			Commonbtn
		},
		props: {
			tableData: {
				type: Array,
				default: () => {
					return []
				}
			},
			total: {
				type: Number,
				default: 1
			},
			isLoading: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				pageNo: 1,
				pageSize: 20,
				headerData: [
					{
						prop: "Year",
						label: "年度",
						columnwidth: "80"
					},
					{
						prop: "Quarter",
						label: "周期",
						columnwidth: "70"
					},
					{
						prop: "CusName",
						label: "经销商",
						columnwidth: "200"
					},
					{
						prop: "InvClassName",
						label: "产品线",
						columnwidth: "100"
					},
					{
						prop: "BOSSCustomer",
						label: "关联公司",
						columnwidth: "200"
					},
					{
						prop: "BOSSName",
						label: "公司负责人",
						columnwidth: "150"
					},
					{
						prop: "LEVEL2",
						label: "LEVEL2",
						columnwidth: ""
					},
					{
						prop: "LEVEL3",
						label: "LEVEL3",
						columnwidth: ""
					},
					{
						prop: "LEVEL4",
						label: "LEVEL4",
						columnwidth: ""
					},
					{
						prop: "Quantity",
						label: "数量",
						columnwidth: "80"
					},
					{
						prop: "StandardSum",
						label: "参考价格",
						columnwidth: ""
					},
					{
						prop: "AverPrice",
						label: "均价",
						columnwidth: ""
					}
				]
			}
		},
		methods: {
			Export() {
				this.$emit('Export')
			},
			ExportList() {
				this.$emit('ExportList')
			},
			handleCurrentChange(pageindex) {
				this.pageNo = pageindex
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.$emit('handleSizeChange', paegSzie)
			},
		}
	}
</script>

<style lang="less" scoped>
	.table {
		width: 100%;
		height: 100%;
	}

	.tables {
		padding: 10px 10px 10px 0px;
	}
</style>
